import { render, staticRenderFns } from "./RosterSettings.vue?vue&type=template&id=c828995e&scoped=true&"
import script from "@/views/Roster/RosterSettings.ts?vue&type=script&lang=ts&"
export * from "@/views/Roster/RosterSettings.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Roster/roster-settings.scss?vue&type=style&index=0&id=c828995e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c828995e",
  null
  
)

export default component.exports